/***
 * 创建人：李珊
 * 时间：2020-11-30
 * 描述: 网络抓取
 * 使用说明:
 * 更新说明:
 */
import { Component, OnInit, ViewChild } from '@angular/core';
import { DictionaryService } from 'src/app/librarys/serves/public/dictionary.service';
import { KmsEnum } from '../../../serves/kms-enum';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { SwGridTableComponent } from 'src/app/librarys/components/basic-components/sw-table/sw-grid-table/sw-grid-table.component';
import { Router } from '@angular/router';
import { SwTabService } from 'src/app/librarys/serves/public/sw-tab.service';
import { KmsService } from '../../../kms.service';
@Component({
  selector: 'app-web-page-capture',
  templateUrl: './web-page-capture.component.html',
  styleUrls: ['./web-page-capture.component.css']
})
export class WebPageCaptureComponent implements OnInit {
  @ViewChild("swtable") swtable: SwGridTableComponent;    //表格
  // 当前步骤
  stepIndex = 1;
  // 网络抓取类型下拉选项
  resourceCategoryDic = [];
  //绑定的表单数据
  entryModel: any = {
    'termName': '',
    'resourceCategory': '',
    'taskDescription': '',
    'websiteId': ''
  };
  // 抓取网站
  grabSourceList = [];
  // 当前选择的抓取源信息
  selectGrabResource:any = {};
  // 当前正在添加的词条名称
  currentEntry = '';
  // 词条数组
  entryArr = [];
  // 重复添加的任务
  taskRepeatArr = [];
  // 保存抓取任务按钮是否可点击
  clickEnable = true;
  // 是否正在创建抓取任务
  isCreatingTask:boolean = false;
  constructor(
    private kmsService: KmsService,
    private dicService: DictionaryService,
    private router:Router,
    private box: SwMassageBoxService,
    private tabService: SwTabService //Tab页服务
  ) { }

  ngOnInit() {
    // 获取网络抓取的资源类型选项
    this.getGrabTypteDic();
  }

  // 获取网络抓取的资源类型
  getGrabTypteDic() {
    this.resourceCategoryDic = this.dicService.getDictionaryValueOrName(KmsEnum.KGS_GRAB_TYPE_OPTION);
    this.entryModel.resourceCategory = this.resourceCategoryDic[0].id;
  }

  // 查询抓取源列表
  querySourceList(){
    this.kmsService.getCrawlWebsite({
      'pageNum': 1,
      'pageSize': 50
    }).subscribe(
      data => {
        if(data.code == '200'){
          this.grabSourceList = data.data.records;
        }else{
          this.box.waring('服务器异常，请稍候再试！');
        }
      }
    )
  }

  // 保存词条配置信息
  onSubmit() {
    this.entryModel.termName = this.entryArr.join('、');
    this.toStep(2);
  }

  // 进入下一步
  toStep(index) {
    if (index == 3) {
      // 判断当前抓取源是否为全站类型抓取源，以及是否设置词条关键字
      if (this.selectGrabResource.crawlType == 1 && this.entryModel.termName){
        this.box.danger(this.selectGrabResource.websiteName+'的抓取类型为全站抓取，不允许设置词条关键字！');
        return;
      }
      if(this.selectGrabResource.crawlType == 2  && !this.entryModel.termName){
        this.box.danger(this.selectGrabResource.websiteName+'的抓取类型为关键字抓取，必须设置词条关键字！');
        return;
      }
      this.isCreatingTask = true;
      // 添加爬取任务
      let params = {
        "resourceCategory": this.entryModel.resourceCategory,
        "resourceTotal": 0,
        "websiteId": this.entryModel.websiteId,
        "taskDescribe": this.entryModel.taskDescription,
        "termName": this.entryModel.termName,
        "taskName": "",
        "taskState": 0
      }
      // 设置按钮禁用
      this.clickEnable = false;
      this.kmsService.saveOrUpdateCrawlTask(params).subscribe(
        data => {
          this.isCreatingTask = false;
          this.clickEnable = true;
          if(data.code == '200'){
            this.box.success('抓取任务创建成功！');
            this.tabService.closeUrl("/kms/WebPageCapture", true);
            this.router.navigate(['/kms/MaterialCapture'], {queryParams: {Title: '抓取任务管理'}});
            this.tabService.refurbis("/kms/MaterialCapture");
          }else{
            this.box.danger('服务器异常，请稍后再试！');
          }
        }
      );
    }else{
      this.stepIndex = index;
      // 查询抓取源列表
      if(this.grabSourceList.length == 0){
        this.querySourceList();
      }
    }
  }

  // enter键触发添加词条
  enterAdd(event){
    if(event.keyCode == '13' && this.currentEntry){
      this.addEntry();
    }
  }

  // 添加词条
  addEntry() {
    const len = this.entryArr.filter(item => item == this.currentEntry).length;
    if( len > 0 ){
      this.box.danger('当前关键词已添加！');
      return;
    }
    this.entryArr.push(this.currentEntry);
    this.currentEntry = '';
  }

  // 移除词条
  removeEntry(index) {
    this.entryArr.splice(index, 1);
  }

  //  表格选择数据
  outSelectData(event) {
    //获取当前选中的所有数据
    if(event['websiteId']){
      this.selectGrabResource = event;
      this.entryModel.websiteId = event.websiteId;
    }else{
      this.selectGrabResource = {};
      this.entryModel.websiteId = '';
    }
  }
}
